export const PLAN_RENEWAL_REMINDER_DAYS = 7;
export const PLAN_RENEWAL_REMINDER_DISMISSED_KEY = 'planRenewalReminderDismissed';

export function isSubscriptionExpired(profile) {
  return Boolean(profile?.subscription_expired);
}

/**
 * Days until paid subscription period ends (ceil). Null when not applicable.
 * Returns 0 when the period has ended but access is still full (pre-restriction edge).
 * @param {object|null} profile
 * @returns {number|null}
 */
export function getPlanRenewalDaysRemaining(profile) {
  if (!profile) return null;
  if (String(profile.payment_status || '').toLowerCase() !== 'paid') return null;
  if (profile.access_mode === 'billing_only') {
    return isSubscriptionExpired(profile) ? 0 : null;
  }

  const expiresAt = profile.current_plan_expires_at;
  if (!expiresAt) return null;

  const end = new Date(expiresAt);
  if (Number.isNaN(end.getTime())) return null;

  const diffMs = end.getTime() - Date.now();
  if (diffMs <= 0) return 0;

  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

export function shouldShowPlanRenewalReminder(daysRemaining) {
  return (
    typeof daysRemaining === 'number' &&
    daysRemaining >= 0 &&
    daysRemaining <= PLAN_RENEWAL_REMINDER_DAYS
  );
}

export function formatPlanRenewalLabel(daysRemaining) {
  if (daysRemaining === 0) return 'Subscription expired';
  if (daysRemaining === 1) return 'Expires in 1 day';
  return `Expires in ${daysRemaining} days`;
}
